import FulfillmentItem from './fulfillmentItem/FulfillmentItem';

const FulfillmentDetails = (props) => {
  const { order, settings } = props;
  if (order.fulfillments.length === 0) {
    return null;
  }
  return (
    <div className="c7-order__customer-detail">
      <h4>Fulfillment information</h4>
      <div>
        <span>
          <strong>Fulfillment Information</strong>
          <br />
          Status: {order.fulfillmentStatus}
        </span>
      </div>
      <div className="c7-order__customer-detail__fulfillments">
        {order.fulfillments.map((fulfillmentItem) => (
          <FulfillmentItem
            key={fulfillmentItem.id}
            fulfillmentItem={fulfillmentItem}
            settings={settings}
          />
        ))}
      </div>
    </div>
  );
};

export default FulfillmentDetails;
